import { FC, ReactNode } from 'react'

import { Add, Search } from '@mui/icons-material'
import { Button, InputAdornment, Stack, TextField } from '@mui/material'

type ListSearch = {
  value: string
  onChange: (value: string) => void
  // Also the field's accessible name.
  placeholder: string
  minWidth?: number
}

type ListAdd = {
  label: string
  onClick: () => void
  disabled?: boolean
}

type InternalListToolbarProps = {
  search?: ListSearch
  add?: ListAdd
  // Shown after the search field, e.g. filters or a row count.
  children?: ReactNode
  // Right-aligned before the add button.
  actions?: ReactNode
}

/** The row above an internal list: search on the left, then any filters, and the actions with the add button on the right. */
export const InternalListToolbar: FC<InternalListToolbarProps> = ({ search, add, children, actions }) => {
  const addButton = add && (
    <Button variant="contained" startIcon={<Add />} onClick={add.onClick} disabled={add.disabled} sx={actions ? undefined : { ml: 'auto' }}>
      {add.label}
    </Button>
  )

  return (
    <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap" useFlexGap mb={2}>
      {search && (
        <TextField
          size="small"
          value={search.value}
          onChange={(event) => search.onChange(event.target.value)}
          placeholder={search.placeholder}
          inputProps={{ 'aria-label': search.placeholder }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
          sx={{ minWidth: search.minWidth ?? 320 }}
        />
      )}
      {children}
      {actions ? (
        <Stack direction="row" spacing={1} sx={{ ml: 'auto' }}>
          {actions}
          {addButton}
        </Stack>
      ) : (
        addButton
      )}
    </Stack>
  )
}
